var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAbc = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_425_28",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_425_28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.75 11.25C12.5375 11.25 12.3595 11.178 12.216 11.034C12.072 10.8905 12 10.7125 12 10.5V7.5C12 7.2875 12.072 7.10925 12.216 6.96525C12.3595 6.82175 12.5375 6.75 12.75 6.75H15C15.2125 6.75 15.3905 6.82175 15.534 6.96525C15.678 7.10925 15.75 7.2875 15.75 7.5V8.25H14.625V7.875H13.125V10.125H14.625V9.75H15.75V10.5C15.75 10.7125 15.678 10.8905 15.534 11.034C15.3905 11.178 15.2125 11.25 15 11.25H12.75ZM7.125 11.25V6.75H10.125C10.3375 6.75 10.5158 6.82175 10.6598 6.96525C10.8033 7.10925 10.875 7.2875 10.875 7.5V8.25C10.875 8.4625 10.8033 8.6405 10.6598 8.784C10.5158 8.928 10.3375 9 10.125 9C10.3375 9 10.5158 9.07175 10.6598 9.21525C10.8033 9.35925 10.875 9.5375 10.875 9.75V10.5C10.875 10.7125 10.8033 10.8905 10.6598 11.034C10.5158 11.178 10.3375 11.25 10.125 11.25H7.125ZM8.25 8.4375H9.75V7.875H8.25V8.4375ZM8.25 10.125H9.75V9.5625H8.25V10.125ZM2.25 11.25V7.5C2.25 7.2875 2.322 7.10925 2.466 6.96525C2.6095 6.82175 2.7875 6.75 3 6.75H5.25C5.4625 6.75 5.64075 6.82175 5.78475 6.96525C5.92825 7.10925 6 7.2875 6 7.5V11.25H4.875V10.125H3.375V11.25H2.25ZM3.375 9H4.875V7.875H3.375V9Z",
    fill: "#1C1B1F"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAbc);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/abc.fa92eb95a86780ca7d9d6757516f6e61.svg";